// extracted by mini-css-extract-plugin
module.exports = {"playerBackButton":"_15r1fpTMqOSlkD3SYmIaok"};